import React, { useState, useEffect } from "react";  // Make sure to include useEffect
import {RadioButtonInput } from '../../components/FormInitiators';
import DynamicTable2 from "../../components/DynamicTable2";


const pensionForm2 = ({ formData, setFormData, onFormDataChange, onBack, onNext }) => {
  

  const handleInputChange = ({ target: { name, value } }) => {
    onFormDataChange({ [name]: value });
  };

  const onTableDataChange = (key) => (rows) => {
    setFormData((prevState) => {
      return { ...prevState, [key]: rows };
    });
  };

  return (
  <div className="google_forms">
      <div className="forms">
    <form className="seventh-pay-arrears-form">
        <h3>Family Details</h3>

        <label>
        Name  of the Spouse:
        <input type="text" name="spouseName" value={formData.spouseName} onChange={handleInputChange} />
        </label>

        <label>
        Date of birth of Spouse:
        <input type="date" name="spouseDOB" value={formData.spouseDOB} onChange={handleInputChange} />
        </label>

          <label>
          Spouse Relationship with servant:
          </label>
          
          <label>
                <RadioButtonInput
                  value={formData.spouceRelation} 
                  onChange={handleInputChange}
                  name="spouceRelation"  
                  orientation="horizontal"  
                  options={[
                    { value: 'husband', label: 'Husband' },
                    { value: 'wife', label: 'Wife' }
                  ]}         
                />
            
        </label>

        <DynamicTable2
        tableName="Children Information"
        columns={[
          { header: "Name of Child", key: "nameChild", type: "text" },
          { header: "Date of Birth", key: "dobChild", type: "date",  disableFirstRow: false},
          { header: "Relationship", key: "relationship", type: "dropdown", options: ["Son", "Daughter"] },
        
        ]}
        localStorageKey="childDetails"
        rows={formData.childDetails}  
        onTableDataChange={onTableDataChange("childDetails")}
      />          
        
     
      {/* Navigation Buttons */}
      <div className="seventh-pay-arrears-buttons-container">
        <button type="button" onClick={onBack}>Back</button>
        <button type="button" onClick={onNext}>
         Next
        </button>
      </div>
    </form>
    </div>
    </div>
  );
};

export default pensionForm2;
